// extracted by mini-css-extract-plugin
export default {"menuButton":"styles_menuButton__jWEIY","menuLink":"styles_menuLink__SUwvj","menu":"styles_menu__uAmMQ"};